import { createFileRoute } from "@tanstack/react-router";
import { CreditCardIcon } from "lucide-react";
import { SubscriptionsTable } from "@/components/admin/subscriptions-table";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/subscriptions")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities),
  component: AdminSubscriptionsPage,
});

function AdminSubscriptionsPage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
          <CreditCardIcon className="size-3.5" />
          Operate
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="font-heading text-3xl font-semibold tracking-tight">Subscriptions</h1>
          <p className="max-w-2xl text-sm text-muted-foreground">
            Live billing pulled from Polar — active plans, monthly recurring revenue, and who's
            canceling.
          </p>
        </div>
      </header>

      <SubscriptionsTable />
    </div>
  );
}
